module.exports = __webpack_public_path__ + "static/img/kefu.235493e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kefu.png
// module id = KGy/
// module chunks = 55